import { defineStore } from 'pinia';
import type { TEvent, TEvents } from './types';
import eventService from './api';

interface State {
	eventData: TEvent | undefined;
	events: TEvents;
}

export const useDialogEventStore = defineStore('DialogEvent', {
	state: (): State => ({
		eventData: undefined,
		events: [],
	}),

	actions: {
		async getCurrentEvent() {
			const data = await eventService.fetchCurrentEvent();

			if ('error' in data) {
				console.error(data);
				return null;
			}

			this.eventData = data;
		},

		async getEvents() {
			const data = await eventService.fetchEvents();

			if ('error' in data) {
				console.error(data);
				return null;
			}

			this.events = data;
		},
	},
});
